import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { AssistantsList } from './AssistantsList';
import { ThreadDetail } from './ThreadDetail';
import { RunMonitor } from './RunMonitor';

interface Props {
  agentId: string;
  agentSlug: string;
}

export const AssistantsTab = ({ agentId, agentSlug }: Props) => {
  const [subTab, setSubTab] = useState(0);

  return (
    <div>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        sx={{
          mb: 3,
          '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, minHeight: 40 },
          '& .MuiTabs-indicator': { height: 2 },
        }}
      >
        <Tab label="Assistants" />
        <Tab label="Threads" />
        <Tab label="Runs" />
      </Tabs>

      {subTab === 0 && <AssistantsList agentSlug={agentSlug} />}
      {subTab === 1 && <ThreadDetail agentId={agentId} agentSlug={agentSlug} />}
      {subTab === 2 && <RunMonitor agentId={agentId} agentSlug={agentSlug} />}
    </div>
  );
};
